import React, { useEffect, useState } from "react";
import Navigation from "../Navigation/Navigation";
import { MdKeyboardArrowLeft, MdEast } from "react-icons/md";
// import Tab from "react-bootstrap/Tab";
// import Tabs from "react-bootstrap/Tabs";
import VouchersDashboard from "../VouchersDashboard/VouchersDashboard";
// import ManageVouchers from "../ManageVouchers/ManageVouchers";
// import CouponsDashboard from "../CouponsDashboard/CouponsDashboard";
// import ManageCoupons from "../ManageCoupons/ManageCoupons";
// import UserManagement from "../UserManagement/UserManagement";
import { Link, NavLink } from "react-router-dom";
import PrivacyTermsConditions from "../../Components/PrivacyTermsConditions/PrivacyTermsConditions";

const MyAccVouchersDashboard = () => {
  const [currentTab, setcurrentTab] = useState("");

  const path = window.location.href;
  const endPath = path.split("/");

  // const handleToggleTab = (i) => {
  //   if (i === 0) {
  //     setcurrentTab("vouchersdashboard");
  //   }
  // };

  useEffect(() => {
    if (endPath[4] === "vouchers-dashboard") {
      setcurrentTab("vouchersdashboard");
    }
  }, []);

  return (
    <>
      <div className="gray-bg">
        <div className="navbar-section p-0">
          <Navigation />
        </div>
        <div className="main-content pt-5 pr-3 pb-4">
          <p className="page-text dashboard">
            <Link to={"/dashboard"}>
              <MdKeyboardArrowLeft className="arrow-left" />
              Back
            </Link>
          </p>
          <p className="page-maintitle">My Account</p>
          <div className="acc-dashboard mt-4">
            <div className="mb-2 tabs_ul">
              <NavLink
                to={""}
                className={
                  currentTab === "vouchersdashboard" ? " activeTab" : "tabs_li"
                }
              >
                Vouchers Dashboard
              </NavLink>
              <NavLink to={"/my-account/manage-vouchers"} className={"tabs_li"}>
                Manage Vouchers
              </NavLink>
              <NavLink
                to={"/my-account/coupons-dashboard"}
                className={"tabs_li"}
              >
                Coupons Dashboard
              </NavLink>
              <NavLink to={"/my-account/manage-coupons"} className={"tabs_li"}>
                Manage Coupons
              </NavLink>
            </div>

            <div className="mt-3">
              <VouchersDashboard />
            </div>

            {/* <Tabs
              defaultActiveKey="vouchers-dashboard"
              id="uncontrolled-tab-example"
              className="mb-3 my-account"
            >
              <Tab eventKey="vouchers-dashboard" title="Vouchers Dashboard">
                <VouchersDashboard />
              </Tab>
              <Tab eventKey="manage-vouchers" title="Manage Vouchers">
                <ManageVouchers />
              </Tab>
              <Tab eventKey="couponsdashboard" title="Coupons Dashboard">
                <CouponsDashboard />
              </Tab>
              <Tab eventKey="manage-coupons" title="Manage Coupons">
                <ManageCoupons />
              </Tab>
              <Tab eventKey="user-management" title="User Management">
                <UserManagement />
              </Tab>
            </Tabs> */}
          </div>
        </div>
      </div>
      <PrivacyTermsConditions />
    </>
  );
};

export default MyAccVouchersDashboard;
